import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

// -------------------- Types --------------------

interface ThemeConfig {
  primaryColor: string;
  primaryBorderColor: string;
  primarybuttonBackGroundColor: string;
  secondaryColor: string;
  writeColorbuttonBackGroundColor: string;
  writeColor: string;
  boxshadow: string;
  backgroundGradient: string;
  tabColor: string;
  tab1Color: string;
  tab2Color: string;
  tab3Color: string;
}

export interface EnvironmentConfig {
  ID: string;
  SIMPLIFIED_FORMS: string;
  TABLE_DATA_CACHING: string;
  IDLE_SESSION_TIME_OUT: string;
  ENABLE_EXPORT_PDF: string;
  ENABLE_EXPORT_EXCEL: string;
  BULK_UPLOAD_FILE_LIMIT: string;
  PAGINATION_FETCH_PERCALL_ROWS: string;
  theme: ThemeConfig;
}

interface EnvDataState {
  data: EnvironmentConfig | null;
  currentEnv: EnvironmentConfig | null;
  loading: boolean;
  error: string | null;
}

// -------------------- Initial State --------------------

const initialState: EnvDataState = {
  data: null,
  currentEnv: null,
  loading: false,
  error: null,
};

// -------------------- Slice --------------------

const envDataSlice = createSlice({
  name: "envData",
  initialState,
  reducers: {
    setEnvData: (state, action: PayloadAction<EnvironmentConfig>) => {
      state.data = action.payload;
      state.currentEnv = action.payload; // ✅ single environment
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setEnvData, setLoading, setError } = envDataSlice.actions;
export default envDataSlice.reducer;